import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useContext, useEffect, useState } from "react";
import PoliticalPartyService from "../../services/PoliticalPartyService";
import { Button } from "primereact/button";
import { AppDB } from "../../App";
import { CandidateDBContext } from "./CandidateDBContext";
import { candidateService } from "../../services/CandidateService";

export default function ({ header = null }) {
	var { selectedCanditate } = useContext(CandidateDBContext);

	
	var [loading, setLoading] = useState(true);
	var [refresh, setRefresh] = useState(false);
	var [users, setUsers] = useState([]);
	var { toast } = useContext(AppDB);

	var politicalPartyService = new PoliticalPartyService();

	useEffect(() => {
		setLoading(true);

		candidateService.getUsersByID(selectedCanditate.candidateID).then((data) => {
			setUsers(data);
			setLoading(false);
		});
	}, [refresh]);

	function createUser() {
		setLoading(true);
		politicalPartyService
			.createUser({
				candidateID: selectedCanditate.candidateID,
				isCandidate: true
			})
			.then((res) => {
				setLoading(false);
				if (res.success) {
					setRefresh(!refresh);
					toast.show({
						severity: "success",
						detail: "User created",
						life: 2500
					});
				} else {
					toast.show({
						severity: "error",
						detail: res.message,
						life: 2500
					});
				}
			});
	}

	return (
		<>
			<div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center my-2">
				<div>
					<Button
						label="Create User"
						loading={loading}
						onClick={() => {
							createUser();
						}}
						className="p-button-success mr-3"
					/>
				</div>
			</div>

			<div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center my-2">
				{header !== null && <h5>{header}</h5>}
			</div>
			<DataTable
				className="remove-border"
				size="small"
				scrollable={true}
				value={users}
				dataKey="id"
				loading={loading}
				responsiveLayout="scroll"
				style={{ width: "100%" }}
			>
				<Column field="email" header="Email" sortable body={(e) => e?.email}></Column>
				<Column field="displayName" header="Username" sortable body={(e) => e?.displayName}></Column>
				<Column
					field="active"
					header="Status"
					body={(e) =>
						e?.active ? (
							<Button label="Active" style={{ textAlign: "center", height: "30px" }} className="p-button-success p-button-rounded" />
						) : (
							<Button label="Not Active" style={{ textAlign: "center", height: "30px" }} className="p-button-danger p-button-rounded" />
						)
					}
					sortable
				></Column>
			</DataTable>
		</>
	);
}
